// extracted by mini-css-extract-plugin
module.exports = {"alert":"TruoraAlertCountStock-module__alert___1buqr"};